var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"bigButton",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.onClick($event)}}},[(_vm.iconSrc)?_c('img',{class:("icon-" + _vm.icon),attrs:{"src":_vm.iconSrc,"aria-hidden":"true"}}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-239f480f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BigButton.vue
// module id = null
// module chunks = 